var parent = typeof pfKioskAdmin === 'object' ? pfKioskAdmin : pfKiosk;
var debug = debug || null;
(function (module) {
  module.Locking = (function () {
    'use strict';
    var _socketEventName = 'amenity-lock';
    var _socket = {};
    var _locks = [];
    var _kiosks = [];
    var _timer = 0;
    var _callback;
    var log = debug('Kiosk:Locking');

    function init(socket) {
      _socket = socket;
      _socket.on('kiosks', updateKiosks);
      _socket.on(_socketEventName, onLock);
    }

    var updateKiosks = function updateKiosks(data) {
      _kiosks = data.filter(function(k){
        return k.socket.id !== _socket.id; //&& k.name.indexOf("Rad") === -1
      });
    };

    var onLock = function onLock (lock) { 
      if (common.configData.appLogging) {
        pfKioskServices.trackEvent({
          name: 'Equipment Guid Tracking',
          properties: {
            reason: 'Logging On',
            adminKiosk: module.isAdmin ? 'true' : 'false',
            function: 'onLock',
            equipmentGuid: lock.eq,
            lock: JSON.stringify(lock),
            kioskBuild: config.BUILD
          }
        });
      }
      if (lock.eq.length <= 4) {
        pfKioskServices.trackEvent({
          name: 'Equipment Guid Tracking',
          properties: {
            reason: 'Invalid Guid',
            adminKiosk: module.isAdmin ? 'true' : 'false',
            function: 'onLock',
            equipmentGuid: lock.eq,
            lock: JSON.stringify(lock),
            kioskBuild: config.BUILD
          }
        });
      }

      switch (lock.status) {
        case 'request':
          if(lock.id === module.socket.id){
            return;
          }
          var available = true;
          log('received lock ' + lock.status + ' for ' + common.getAmenityType(lock.eq).amenityName + ' @ ' + moment(+lock.time).format('h:mma'));
          var existingLock = getLock(lock);
          var status = existingLock.length || !available ? 'deny' : 'grant';
          if (!existingLock.length) {
            if (module.isAdmin) {
              var fcfsCheck = ScheduleHelper.checkSchedule(lock);
              if (!fcfsCheck) {
                if (lock.id !== _socket.id) {
                  lock.status = 'deny';
                  status = 'deny';
                }
                log('lock for ' + common.getAmenityType(lock.eq).amenityName + ' @ ' + moment(+lock.time).format('h:mma') + ' is not best for First Come First Serve');
              } else {
                var block = $('.block[data-time="' + lock.time + '"]').find('.box[data-amenityequipmentguid="' + lock.eq + '"]');
                if (block && (!block.hasClass('available') || block.hasClass('downloading') || block.hasClass('locked'))) {
                  status = 'deny';
                  log('schedule exists for lock - denying lock request');
                }
              }
            }
            lock.status = status;
            _socket.emit(_socketEventName, lock);
            log('emitting lock status: ' + lock.status);
          } else {
            log('lock exists for ' + common.getAmenityType(lock.eq).amenityName + ' @ ' + moment(+lock.time).format('h:mma'));
            if (lock.id !== _socket.id) {
              lock.status = 'deny';
              _socket.emit(_socketEventName, lock);
              log('emitting lock status: ' + lock.status);
            }
          }
          break;
        case 'grant':
          addResponse(lock);
          break;
        case 'deny':
          addResponse(lock);
          break;
        case 'granted':
          disableAmenity(lock);
          break;
        case 'denied':
          break;
        case 'remove':
          enableAmenity(lock);
          break;
        default:
          lock.status = 'request';
          requestLock(lock);
          break;
      }
    };

    var disableAmenity = function (lock) {
      if (common.getAmenityType(lock.eq)) {
        log('locking ' + common.getAmenityType(lock.eq).amenityName + ' @ ' + moment(+lock.time).format('h:mma'));
      }

      if (module.isAdmin) {
        var $block = $('.block[data-time="' + lock.time + '"]').find('.box[data-amenityequipmentguid="' + lock.eq + '"]');

        if ($block) {
          $block.addClass('locked');
        }

      } else {
        var $sel = $('li[data-time="' + lock.time + '"][data-amenityequipmentids*="' + lock.eq + '"]');

        if ($sel) {

          $sel
            .attr('data-amenityequipmentids', function (v) {
              return $(this).attr('data-amenityequipmentids').split(',').map(function (id) {
                return id === lock.eq ? '-' + lock.eq : id;
              });
            })
            .find('.btn').addClass(function () {
              var amenityEquipment = $(this).parent('li').attr('data-amenityequipmentids').split(',');
              var blockedEquipment = $(this).parent('li').attr('data-blocked').split(',');
              var scheduledEquipment = $(this).parent('li').attr('data-scheduled').split(',');

              var available = amenityEquipment.filter(function (id) {
                var notLocked = id[0] !== '-';
                var notBlocked = blockedEquipment.indexOf(id) === -1;
                var notScheduled = scheduledEquipment.indexOf(id) === -1;
                return (notLocked && notBlocked && notScheduled);
              });

              return (available.length === 0) ? 'disabled' : '';
            });
        }
      }
    };

    var enableAmenity = function (lock) {
      if (common.getAmenityType(lock.eq)) {
        log('unlocking ' + common.getAmenityType(lock.eq).amenityName + ' @ ' + moment(+lock.time).format('h:mma') + ' ' + lock.reason || '');
      }

      if (module.isAdmin) {
        var $block = $('.block[data-time="' + lock.time + '"]').find('.box[data-amenityequipmentguid="' + lock.eq + '"]');

        if ($block) {
          $block.removeClass('locked');
        }
      } else {
        var $sel = $('li[data-time="' + lock.time + '"][data-amenityequipmentids*="' + lock.eq + '"]');

        if ($sel) {
          $sel
            .attr('data-amenityequipmentids', function (v) {
              return $(this).attr('data-amenityequipmentids').split(',').map(function (id) {
                return id === '-' + lock.eq ? lock.eq : id;
              });
            })
            .find('.btn').removeClass(function () {
              var amenityEquipment = $(this).parent('li').attr('data-amenityequipmentids');
              var blockedEquipment = $(this).parent('li').attr('data-blocked');
              var scheduledEquipment = $(this).parent('li').attr('data-scheduled');
              var available = amenityEquipment.split(',').filter(function (id) {
                return (id[0] !== '-' && blockedEquipment.indexOf(id) === -1 && scheduledEquipment.indexOf(id) === -1);
              });
              return !available.length ? '' : 'disabled';
            });
        }
      }
    };

    var clearExistingLocks = function () {
      log('clearing all existing locks');
      for (var i = 0; i < _locks.length; i++) {
        var lock = _locks[i];
        removeLock(lock);
      }
    };

    var requestLock = function requestLock (lock, callback) {      
      if (common.configData.appLogging) {
        pfKioskServices.trackEvent({
          name: 'Equipment Guid Tracking',
          properties: {
            reason: 'Logging On',
            adminKiosk: module.isAdmin ? 'true' : 'false',
            function: 'requestLock',
            equipmentGuid: lock.eq,
            lock: JSON.stringify(lock),
            kioskBuild: config.BUILD
          }
        });
      };
      if (lock.eq.length <= 4) {
        pfKioskServices.trackEvent({
          name: 'Equipment Guid Tracking',
          properties: {
            reason: 'Invalid Guid',
            adminKiosk: module.isAdmin ? 'true' : 'false',
            function: 'requestLock',
            equipmentGuid: lock.eq,
            lock: JSON.stringify(lock),
            kioskBuild: config.BUILD
          }
        });
      }
      _callback = callback;
      lock.status = 'request';
      lock['id'] = _socket.id;
      addLock(lock);
      log('requesting lock from ' + (_kiosks.length - 1) + ' other kiosks');
      if (_kiosks.length > 1) {
        _socket.emit(_socketEventName, lock);
        setTimer(lock);
      } else {
        lock.status = lock['response'].indexOf('deny') !== -1 ? 'denied' : 'granted';
        _socket.emit(_socketEventName, lock);
        callback(lock);
      }
    };

    var addLock = function addLock(data) {
      log('locking ' + common.getAmenityType(data.eq).amenityName + ' @ ' + moment(+data.time).format('h:mma'));
      data['response'] = ['grant'];
      var lock = getLock(data);
      if (lock.length === 0) {
        _locks.push(data);
      }
    };

    var removeLock = function removeLock(data) {
      var existingLock = getLock(data);

      if (!existingLock.length) {
        return;
      }
      log('unlocking ' + common.getAmenityType(data.eq).amenityName + ' @ ' + moment(+data.time).format('h:mma') + ' ' + data.reason || '');
      for (var i = 0; i < _locks.length; i++) {
        var lock = _locks[i];
        if (lock.eq === data.eq && lock.time === +data.time) {
          _locks.splice(i, 1);
          if (!module.isAdmin) {
            $('li[data-time="' + lock.time + '"][data-amenityequipmentids*="' + lock.eq + '"]').attr('data-amenityequipmentids', function (v) {
              return $(this).attr('data-amenityequipmentids').split(',').map(function (id) {
                return id === '-' + lock.eq ? lock.eq : id;
              });
            });
          }
        }
      }
      enableAmenity(data);
      data.status = 'remove';
      log('emitting lock remove ' + common.getAmenityType(data.eq).amenityName + ' @ ' + moment(+data.time).format('h:mma'));
      _socket.emit(_socketEventName, data);
    };

    var getLock = function getLock(data) {
      return _locks.filter(function (lock) {
        return lock.eq === data.eq && lock.time === data.time;
      });
    };

    var addResponse = function addResponse(data) {
      var lock = getLock(data);
      if (lock.length) {
        log('response for lock ' +  common.getAmenityType(data.eq).amenityName + ' @ ' + moment(+data.time).format('h:mma') + ' : ' + data.status);
        lock[0].response.push(data.status);
        if (_kiosks.length === lock[0].response.length) {
          clearTimeout(_timer);
          lock[0].status = lock[0]['response'].indexOf('deny') !== -1 ? 'denied' : 'granted';
          log('responses: ' + lock[0]['response'].join());
          if (lock[0].status === 'denied') {
            _locks = [];
          }
          _socket.emit(_socketEventName, lock[0]);
          _callback(lock[0]);
        }
      }
    };

    var setTimer = function setTimer(data) {
      log('starting response timer for 2 seconds');
      _timer = setTimeout(function () {

        var existingLock = getLock(data);
        existingLock.filter(function (lock) {
          return lock.status !== 'request';
        });
        if (existingLock.length) {
          existingLock[0].status = existingLock[0]['response'].indexOf('deny') !== -1 ? 'denied' : 'granted';
          _socket.emit(_socketEventName, existingLock[0]);
          _callback(existingLock[0]);
          log('response timer expired, response ' + existingLock[0].status);
          if (existingLock[0].status === 'denied') {
            _locks = [];
          }
        }
      }, 20000);
      return _timer;
    };

    var getLocks = function () {
      return _locks;
    };

    return {
      init: init,
      onLock: onLock,
      removeLock: removeLock,
      getLock: getLock,
      getLocks: getLocks,
      addResponse: addResponse,
      requestLock: requestLock,
      clearExistingLocks: clearExistingLocks
    };
  })();

})(parent);
